export default {
    auth_request(state){
        state.status = 'loading';
    },
    set_role(state, role) {
        if (!role) {
            state.role = 'ROLE_USER';
            return;
        }

        state.role = role;
    },
    setUserAFM(state, afm) {
        state.userAFM = afm
    },
    setUser(state, user) {
        state.user = user;
    },
    set_token(state, token) {
        state.token = token
    },
    setTaxisChecked(state, isTaxisChecked) {
        state.isTaxisChecked = isTaxisChecked
    },
    logout(state){
        state.status = '';
        state.token = '';
        state.userAFM = '';
        state.user = {};
        state.role = '';
        state.isTaxisChecked = false;
    },
    setEmailVerified(state, isEmailVerified) {
        state.user.isEmailVerified = isEmailVerified
    },
    setEmail(state, email) {
        state.user.email = email
    }
}